module.exports = __webpack_public_path__ + "img/landingPageDrum.a61fb137.svg";